import { useState, useEffect, useRef } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft, faSave } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from "react-router-dom";
import { EstadoInterface, EmpresaInterface as iData, MunicipioInterface } from "../../interfaces";
import empresaService from "../../services/EmpresaService";
import { JAlerta, MakeMessageError } from "../../components/Components";
import auxService from "../../services/AuxService";
import { rgx_numberOnly } from "../../utils/utils";

const initial = {
    id: '',
    name: '',
    cpfcnpj: '',
    xfant: '',
    ie: '',
    xlgr: '',
    nro: '',
    xcpl: '',
    cep: '',
    xbairro: '',
    estado_id: 0,
    municipio_id: 0,
    fone: '',
    celular: '',
    email: '',
    certificado: '',
    imagem: '',
    tpamb: 2,
    active: true
}

const initialFieldsError = {
    name: [],
    xfant: [],
    cpfcnpj: [],
    ie: [],
    xlgr: [],
    nro: [],
    cep: [],
    xcpl: [],
    xbairro: [],
    estado_id: [],
    municipio_id: [],
    fone: [],
    celular: [],
    email: [],
}

export default function FormEmpresa() {
    const navigate = useNavigate()
    const { id } = useParams<{ id: string }>();
    const [showError, setShowError] = useState(false);
    const [showMessageError, setShowMessageError] = useState('');
    const [errors, setErrors] = useState(initialFieldsError);
    const [data, setData] = useState<iData>(initial)
    const [estados, setEstados] = useState<EstadoInterface[]>([{
        id: 0,
        uf: 'Selecione',
        name: 'Selecione',
        cod_ibge: 0,
        pais: { name: 'Brasil' }

    }]);
    const [municipios, setMunicipios] = useState<MunicipioInterface[]>([]);
    const municipioRef = useRef<HTMLSelectElement>(null);
    const cpfcnpjRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        auxService.getEstados().then(data => {
            setEstados([...estados, ...data])
        })

        if (id) {
            cpfcnpjRef.current?.setAttribute('disabled', '');
            empresaService.get(id)
                .then(data => {
                    setData(data);
                    auxService.getMunicipios(data.estado_id).then(res => {
                        setMunicipios(res)
                    })
                })
                .catch(err => navigate('/empresa'))

        } else {
            municipioRef.current?.setAttribute('disabled', '');
        }
    }, [id])

    //handles
    const handleSubmit = async (e: any) => {
        e.preventDefault();

        if (id) {
            try {
                await empresaService.update(id, data).then(() => {
                    navigate('/empresa')
                });
            } catch (err: any) {
                if (err.response.status === 422) {
                    setErrors(err.response.data)
                }
                if (err.response.status === 403) {
                    setShowError(true)
                    setShowMessageError(err.response.data.message)
                }
                navigate(`/empresa/${id}`)
            }

        } else {
            try {
                await empresaService.create(data).then(() => {
                    navigate('/empresa')
                });

            } catch (err: any) {
                if (err.response.status === 422) {
                    setErrors(err.response.data)
                }
                if (err.response.status === 403) {
                    setShowError(true)
                    setShowMessageError(err.response.data.message)
                }
                navigate("/empresa/create")
            }
        }
    }

    const handleChange = (e: React.ChangeEvent<any>) => {
        const { name, value } = e.target;

        setErrors(prev => ({ ...prev, [name]: "" }));

        const transformers: Record<string, (val: string) => string> = {
            cpfcnpj: rgx_numberOnly,
            ie: rgx_numberOnly,
            cep: rgx_numberOnly
        };

        const newValue = transformers[name] ? transformers[name](value) : value;

        setData(prev => ({ ...prev, [name]: newValue }));
    };

    const handleChangeEstado = (e: any) => {
        const { name, value } = e.target;
        municipioRef.current?.setAttribute('disabled', '');

        setErrors({
            ...errors,
            municipio_id: [],
            [name]: ''
        })

        if (value > 0) {
            auxService.getMunicipios(value).then(data => {
                setMunicipios(data)
                setData((prev) => ({
                    ...prev,
                    municipio_id: data.filter((municipio: MunicipioInterface) => municipio.capital === 1)[0]?.id || 0
                }))
                municipioRef.current?.removeAttribute('disabled');
            }).catch(err => {
                municipioRef.current?.removeAttribute('disabled');
            })
        } else {
            municipioRef.current?.setAttribute('disabled', '');

            setMunicipios([])
            setData((prev) => ({
                ...prev,
                municipio_id: 0
            }))
        }

        setData((prev) => ({
            ...prev,
            [name]: value
        }))

    }

    return (
        <div >
            <JAlerta showError={showError} close={setShowError} messageError={showMessageError} />

            <Form onSubmit={handleSubmit} noValidate>
                <Card className="card-success card-outline">
                    <Card.Header className="d-flex justify-content-between align-items-center">
                        <div className="my-0">
                            <Button variant={id ? 'success' : 'primary'} type="submit">
                                <FontAwesomeIcon icon={faSave} /> {id ? 'Salvar' : 'Criar'}
                            </Button>
                            <Link to="/empresa" className="btn btn-secondary ms-1">
                                <FontAwesomeIcon icon={faArrowLeft} /> Voltar
                            </Link>
                        </div>
                        <div className="h5 py-0 m-0 text-muted">{id ? 'Editar' : 'Nova'} Empresa</div>
                    </Card.Header>

                    <Card.Body>
                        <Row className="g-2">

                            <Col md>
                                <Form.Group className="mb-3" controlId="name">
                                    <Form.Label>Nome/Razão Social</Form.Label>
                                    <Form.Control maxLength={60} name="name" value={data.name}
                                        className={`${errors.name?.length > 0 ? "is-invalid" : ""}`}
                                        type="text" onChange={handleChange} autoFocus />
                                    <MakeMessageError errors={errors} field="name" />
                                </Form.Group>
                            </Col>

                            <Col md>
                                <Form.Group className="mb-3" controlId="cpfcnpj">
                                    <Form.Label>Nome Fantasia</Form.Label>
                                    <Form.Control maxLength={60} name="xfant" value={data.xfant}
                                        className={`${errors.xfant?.length > 0 ? "is-invalid" : ""}`}
                                        type="text" onChange={handleChange} />
                                    <MakeMessageError errors={errors} field="xfant" />
                                </Form.Group>
                            </Col>

                            <Col md={'auto'}>
                                <Form.Group className="mb-3" controlId="cpfcnpj">
                                    <Form.Label>CPF/CNPJ</Form.Label>
                                    <Form.Control maxLength={14} name="cpfcnpj" value={data.cpfcnpj}
                                        className={`${errors.cpfcnpj?.length > 0 ? "is-invalid" : ""}`}
                                        type="text" onChange={handleChange}
                                        ref={cpfcnpjRef} />
                                    <MakeMessageError errors={errors} field="cpfcnpj" />
                                </Form.Group>
                            </Col>

                            <Col md={'auto'}>
                                <Form.Group className="mb-3" controlId="ie">
                                    <Form.Label>Inscrição Estadual</Form.Label>
                                    <Form.Control maxLength={14} name="ie" value={data.ie}
                                        className={`${errors.ie?.length > 0 ? "is-invalid" : ""}`}
                                        type="text" onChange={handleChange} />
                                    <MakeMessageError errors={errors} field="ie" />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="g-2">
                            <Col md>
                                <Form.Group className="mb-3" controlId="xlgr">
                                    <Form.Label>Logradouro</Form.Label>
                                    <Form.Control maxLength={60} name="xlgr" value={data.xlgr}
                                        className={`${errors.xlgr?.length > 0 ? "is-invalid" : ""}`}
                                        type="text" onChange={handleChange} />
                                    <MakeMessageError errors={errors} field="xlgr" />
                                </Form.Group>
                            </Col>

                            <Col md={2}>
                                <Form.Group className="mb-3" controlId="nro">
                                    <Form.Label>Número</Form.Label>
                                    <Form.Control maxLength={10} name="nro" value={data.nro}
                                        className={`${errors.nro?.length > 0 ? "is-invalid" : ""}`}
                                        type="text" onChange={handleChange} />
                                    <MakeMessageError errors={errors} field="nro" />
                                </Form.Group>
                            </Col>

                            <Col md={2}>
                                <Form.Group className="mb-3" controlId="cep">
                                    <Form.Label>CEP</Form.Label>
                                    <Form.Control maxLength={8} name="cep" value={data.cep}
                                        className={`${errors.cep?.length > 0 ? "is-invalid" : ""}`}
                                        type="text" onChange={handleChange} />
                                    <MakeMessageError errors={errors} field="cep" />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="g-2">
                            <Col md>
                                <Form.Group className="mb-3" controlId="xcpl">
                                    <Form.Label>Complemento</Form.Label>
                                    <Form.Control maxLength={60} name="xcpl" value={data.xcpl}
                                        className={`${errors.xcpl?.length > 0 ? "is-invalid" : ""}`}
                                        type="text" onChange={handleChange} />
                                    <MakeMessageError errors={errors} field="xcpl" />
                                </Form.Group>
                            </Col>

                            <Col md>
                                <Form.Group className="mb-3" controlId="xbairro">
                                    <Form.Label>Bairro</Form.Label>
                                    <Form.Control maxLength={60} name="xbairro" value={data.xbairro}
                                        className={`${errors.xbairro?.length > 0 ? "is-invalid" : ""}`}
                                        type="text" onChange={handleChange} />
                                    <MakeMessageError errors={errors} field="xbairro" />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="g-2">
                            <Col md={'auto'}>
                                <Form.Group className="mb-3" controlId="estado_id">
                                    <Form.Label>Estado</Form.Label>
                                    <Form.Select name="estado_id" value={data.estado_id}
                                        className={`${errors.estado_id?.length > 0 ? "is-invalid" : ""}`}
                                        onChange={handleChangeEstado}>
                                        {estados.map((estado) => (
                                            <option key={estado.id} value={estado.id}>{estado.uf}</option>
                                        ))}
                                    </Form.Select>
                                    <MakeMessageError errors={errors} field="estado_id" />
                                </Form.Group>
                            </Col>

                            <Col md>
                                <Form.Group className="mb-3" controlId="municipio_id">
                                    <Form.Label>Município</Form.Label>
                                    <Form.Select name="municipio_id" value={data.municipio_id} ref={municipioRef}
                                        className={`${errors.municipio_id?.length > 0 ? "is-invalid" : ""}`}
                                        onChange={handleChange}>

                                        {municipios && (
                                            municipios?.map((municipio) => {
                                                if (!id) {
                                                    return (
                                                        <option selected={municipio.capital === 1}
                                                            key={municipio.id}
                                                            value={municipio.id}>
                                                            {municipio.name}
                                                        </option>
                                                    )
                                                } else {
                                                    return (
                                                        <option selected={data.municipio_id === municipio.id}
                                                            key={municipio.id} value={municipio.id}>
                                                            {municipio.name}
                                                        </option>
                                                    )
                                                }
                                            })
                                        )}
                                    </Form.Select>
                                    <MakeMessageError errors={errors} field="municipio_id" />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="g-2">
                            <Col md={2}>
                                <Form.Group className="mb-3" controlId="fone">
                                    <Form.Label>Telefone</Form.Label>
                                    <Form.Control maxLength={11} name="fone" value={data.fone}
                                        type="text" onChange={handleChange} />
                                    <MakeMessageError errors={errors} field="fone" />
                                </Form.Group>
                            </Col>

                            <Col md={2}>
                                <Form.Group className="mb-3" controlId="celular">
                                    <Form.Label>Celular</Form.Label>
                                    <Form.Control maxLength={11} name="celular" value={data.celular}
                                        type="text" onChange={handleChange} />
                                    <MakeMessageError errors={errors} field="celular" />
                                </Form.Group>
                            </Col>

                            <Col md>
                                <Form.Group className="mb-3" controlId="email">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control maxLength={60} name="email" value={data.email}
                                        type="text" onChange={handleChange} />
                                    <MakeMessageError errors={errors} field="email" />
                                </Form.Group>
                            </Col>

                            <Col md={'auto'}>
                                <Form.Group className="mb-3" controlId="tpamb">
                                    <Form.Label>Tipo Ambiente</Form.Label>
                                    <Form.Select name="tpamb" value={data.tpamb} onChange={handleChange}>
                                        <option value={1}>Produção</option>
                                        <option value={2}>Homologação</option>
                                    </Form.Select>
                                    <MakeMessageError errors={errors} field="tpamb" />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="g-2">

                            <Col md={4}>
                                <Form.Group className="mb-3" controlId="imagem">
                                    <Form.Label>Imagem</Form.Label>
                                    <Form.Control maxLength={60} name="imagem" value={data.imagem}
                                        type="file" onChange={handleChange} />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Form>
        </div>
    );
}
